import { Component, EventEmitter, Output } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { AppSharedModule } from 'app/app-shared.module';
import { PROJECT_COLOR_LIMIT } from 'app/providers/storage-api/project.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ErrorObjectUtils } from 'app/utils/error-object.utils';

@EnableClassTelemetry()
@Component({
  selector: 'app-color-palette-import-dialog',
  imports: [AppSharedModule],
  templateUrl: './color-palette-import-dialog.component.html',
  styleUrls: ['./color-palette-import-dialog.component.scss'],
})
export class ColorPaletteImportDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Output() modalClosed = new EventEmitter<string[]>();

  colorPaletteString: string;
  colorPaletteStatus = ErrorObjectUtils.create();
  colorPalette: string[];

  readonly colorStringRegex =
    /^(?:\s*(rgba?\(\s*(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\s*,\s*){2}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\s*(?:,\s*(?:0\.\d+|1(?:\.0+)?|0))?\s*\))(?:\s*,\s*(rgba?\(\s*(?:(?:25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\s*,\s*){2}(?:25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\s*(?:,\s*(?:0\.\d+|1(?:\.0+)?|0))?\s*\)))*\s*)$/i;

  onValidateColorPalette() {
    const matches = this.colorPaletteString.match(this.colorStringRegex);
    if (!matches) {
      this.colorPalette = undefined;
      ErrorObjectUtils.setError(
        this.colorPaletteStatus,
        translate('color-palette-import.invalid-palette')
      );
      return;
    }

    this.colorPalette = this.colorPaletteString.match(/rgba?\([^)]+\)/gi);
    if (this.colorPalette?.length > PROJECT_COLOR_LIMIT) {
      ErrorObjectUtils.setError(
        this.colorPaletteStatus,
        translate('color-palette-import.too-many-colors', { count: PROJECT_COLOR_LIMIT })
      );
      this.colorPalette = undefined;
      return;
    }

    ErrorObjectUtils.setNoError(this.colorPaletteStatus);
  }

  onCancel() {
    this.modalClosed.emit();
  }

  onImport() {
    this.modalClosed.emit(this.colorPalette);
  }
}
